<template>
  <v-dialog v-model="dialog">
    <template #activator>
        <v-menu bottom left>
            <template v-slot:activator="{ on }">
            <v-btn v-on="on">
                <v-icon left>mdi-printer</v-icon>Print
            </v-btn>
            </template>

            <v-list>
                <v-list-item @click="open()">
                    <v-list-item-title>
                        Client Invoice
                    </v-list-item-title>
                </v-list-item>
                <v-list-item @click="open(true)">
                    <v-list-item-title>
                        Commercial Invoice
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </template>
    <v-card v-if="invoice">
        <v-toolbar elevation="0">
            Invoice # {{ invoice.invoiceNumber }}
        </v-toolbar>
        <v-card-text>
            <v-row>
                <v-col>
                    <pdf-viewer
                        url="invoices/print"
                        :params="{ id: invoice.id, commercial }"
                        :filename="invoice.invoiceNumber"
                        style="width: 300%"
                    ></pdf-viewer>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import PdfViewer from '../PdfViewer.vue';
export default {
    components: { PdfViewer },
    props: {
        invoice: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        dialog: false,
        commercial: false,
        type:''
    }),
    methods: {
        open (commercial = false) {
            this.dialog = true
            this.commercial = commercial
        }
    }
}
</script>

<style>

</style>